// import { useDispatch, useSelector } from "react-redux";
// import { useEffect } from "react";
// import { setActiveTab } from "../filter/durationFilter/store";
// import CustomHookForRuralDetails from "../ruralDetailsCount/CustomHookForRuralDetails";
// interface TabItem {
//   title: string;
//   id: number;
// }

// function Tab({ ...props }) {
//   const dispatch = useDispatch();
//   const selectorData = useSelector((state: any) => state.time?.tab);
//   const { ruralDetailsCount } = CustomHookForRuralDetails();
//   const selectedArea = async(data: TabItem) => { await dispatch(setActiveTab(data)); handleSubmit()};
//   useEffect(() => {
//     if (props?.tabData?.length > 0) {
//       dispatch(setActiveTab(props.tabData[0]));
//     }
//   }, [props?.tabData]);

//   const handleSubmit = async () => {
//     ruralDetailsCount(props?.chartId);
//   };

//   return (
//     <div>
//       <div className="flex rounded-lg ">
//         {props?.tabData?.map((item: TabItem, i: number) => (
//           <button
//             key={i} // ✅ key should be here, not inside a fragment
//             onClick={() => selectedArea(item)}
//             className={`text-[10px] px-3 mr-1 py-1.5 ${
//               selectorData?.id === item.id
//                 ? "bg-[#0BB783] text-white rounded-sm "
//                 : "text-black font-medium cursor-pointer  hover:bg-blue-300 rounded-sm"
//             } transition`}
//           >
//             {item.title}
//           </button>
//         ))}
//       </div>
//     </div>
//   );
// }

// export default Tab;

import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { setActiveTab } from "../filter/durationFilter/store";
import CustomHookForRuralDetails from "../ruralDetailsCount/CustomHookForRuralDetails";

interface TabItem {
  title: string;
  id: number;
}

interface TabProps {
  tabData: TabItem[];
  chartId: string; // use this as Redux key
  props: any;
}

function Tab({ tabData, chartId , props }: TabProps) {
  const dispatch = useDispatch();
  const selectedTab = useSelector((state: any) => state.time?.tabs?.[chartId]);
  const { ruralDetailsCount } = CustomHookForRuralDetails();

  const handleSubmit = async () => {
    if (props?.chartListData?.has_tab) {

        if (selectedTab?.id) {
        ruralDetailsCount(chartId, props);
        }
      } else {
        if (props?.id) {
          ruralDetailsCount(chartId, props);
        }
      }
  };

  const selectedArea = async (data: TabItem) => {
    await dispatch(setActiveTab({ key: chartId, tab: data }));
    handleSubmit();
  };

  useEffect(() => {
    if (tabData?.length > 0) {
      dispatch(setActiveTab({ key: chartId, tab: tabData[0] }));
    }
  }, [tabData, chartId]);

  return (
    <div className="flex rounded-lg">
      {tabData?.map((item, i) => (
        <button
          key={i}
          onClick={() => selectedArea(item)}
          className={`text-[10px] px-3 mr-1 py-1.5 ${
            selectedTab?.id === item.id
              ? "bg-[#0BB783] text-white rounded-sm"
              : "text-black font-medium cursor-pointer hover:bg-blue-300 rounded-sm"
          } transition`}
        >
          {item.title}
        </button>
      ))}
    </div>
  );
}

export default Tab;
